import { Directive, ElementRef, Input, OnChanges, SimpleChange } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { isEqual } from 'lodash';
import { Subscription } from 'rxjs';
import { unsubscribeComponent } from '../../../../shared/helpers/unsubscribe-decorator/unsubscribe-decorators.helper';

@Directive({
  selector: '[rowEdited]',
})
@unsubscribeComponent
export class RowEditedDirective implements OnChanges {
  @Input() formGroup: FormGroup;
  @Input() originalRowValue: object;

  originalForm: FormGroup;
  formSubscription: Subscription;
  hasChanged: boolean;

  constructor(private el: ElementRef) {
    //
  }

  // Use ngOnChanges here to listen on the formGroup changes - jchu
  // which is triggered by selecting a different grouping option  in the parent
  ngOnChanges({ formGroup }: { formGroup: SimpleChange }): void {
    this.reset();
    this.formSubscription = this.formGroup.valueChanges.subscribe(val => {
      const formHasChanged = !isEqual(val, this.originalRowValue);
      if (formHasChanged) {
        this.el.nativeElement.style.fontWeight = 'bold';
        this.formGroup.controls.assessmentDate.markAsDirty();
        this.formGroup.markAsDirty();
      } else {
        this.el.nativeElement.style.fontWeight = 'normal';
        this.formGroup.controls.assessmentDate.markAsPristine();
        this.formGroup.markAsPristine();
      }
    });
  }

  // Use reset here to clean out pending changes that was not saved through form submit - jchu
  reset() {
    if (this.formSubscription) {
      this.formSubscription.unsubscribe();
      if (!this.formGroup.dirty) {
        this.el.nativeElement.style.fontWeight = 'normal';
      } else {
        this.el.nativeElement.style.fontWeight = 'bold';
      }
    }
  }
}
